import { render } from "./create.vue?vue&type=template&id=9c0cd544"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/appointments/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c0cd544"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c0cd544', __exports__)) {
    console.log('reload')
    api.reload('9c0cd544', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=9c0cd544", () => {
    console.log('re-render')
    api.rerender('9c0cd544', render)
  })

}


export default __exports__